import { LandscapeImageCard } from '@bnnvara/cards';
import {
  GridCard,
  LAYOUT_MINIMAL,
  LAYOUT_RECTANGLE,
  LAYOUT_SQUARE,
} from '@bnnvara/cards/src/components/GridCard/GridCard';
import { LandscapeContent } from '@bnnvara/cards/src/components/GridCard/LandscapeContent/LandscapeContent';
import { formatDate } from '@bnnvara/helpers';
import PropTypes from 'prop-types';
import React from 'react';

import resizeImageSource from '../../../helpers/resizeImageSource';

export const VideoCard = ({ title, image, publishDate, layout, ...props }) => {
  const thumbnail = resizeImageSource(
    image ? image.url || image : '/static/fallbackImages/videofallback.jpg',
    450,
    1
  );
  const pubDate = formatDate(publishDate);

  if (layout === null) {
    return (
      <LandscapeImageCard
        title={title}
        thumbnail={thumbnail}
        pubDate={pubDate}
        {...props}
      />
    );
  }

  return (
    <GridCard layout={layout}>
      <LandscapeContent
        title={title}
        pubDate={pubDate}
        backgroundImage={thumbnail}
      />
    </GridCard>
  );
};

VideoCard.defaultProps = {
  image: null,
  layout: null,
};

VideoCard.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  publishDate: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    mobile: PropTypes.oneOf([LAYOUT_MINIMAL, LAYOUT_SQUARE]),
    tablet: PropTypes.oneOf([LAYOUT_MINIMAL, LAYOUT_RECTANGLE, LAYOUT_SQUARE]),
    desktop: PropTypes.oneOf([LAYOUT_RECTANGLE, LAYOUT_SQUARE]),
  }),
};

export default VideoCard;
